// extracted by mini-css-extract-plugin
export var btn = "Content5-module--btn--a60d6";
export var leftSec = "Content5-module--left-sec--5836f";
export var smCenter = "Content5-module--sm-center--81838";